<template>
    <div>

        <b-modal v-model="show" id="modal-mc-comparison-products" title="Comparación con Inteligencia Artificial">
            <p class="text-center mt-4" v-if="!showProgressStatus"><i class="fa fa-info-circle mr-1"></i> Este proceso puede tomar varios minutos.</p>

            <div class="d-flex justify-content-center align-items-center w-100" v-if="scheduledProcessesLoading">
                <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
                <span class="ml-2">Cargando...</span>
            </div>

            <div class="text-center" v-if="showProgressStatus">
                <h5 class="m-0"><strong>{{ getStatusTitleSchedule }}</strong> </h5>
                
                <div class="d-flex justify-content-center align-items-center w-100 mt-3">                                        
                    <b-progress :max="progress.max" height="2rem" show-progress :animated="isCompletedProgress ? false : true">
                        <b-progress-bar :value="progress.value" class="px-3" :variant="getVariantToProgressBar">
                            <span :style="{ color: isCompletedProgress ? 'white' : 'black' }">Estado del proceso: <strong>{{ progress.value }} / {{ progress.max }}</strong> %</span>
                        </b-progress-bar>
                    </b-progress>
                    <b-button variant="outline-info" class="ml-1" :style="{ borderRadius: '50%' }" @click="onHandleRefresh" v-if="!isCompletedProgress">
                        <i class="fa fa-refresh"></i>
                    </b-button>
                </div>
            </div>
            
            <template #modal-footer>
                <div class="w-100">
                    <b-button variant="info" class="float-right" @click="onHandleGenerateProcess" v-if="!scheduledProcessesLoading && getStatusTitleSchedule !== 'EN PROGRESO'">
                        <i class="fa fa-magic mr-1"></i>
                        GENERAR COMPARACIÓN
                    </b-button>
                    <b-button variant="light" class="float-right mr-2" @click="show = false">
                        <i class="fa fa-close mr-1"></i>
                        CERRAR
                    </b-button>
                    
                </div>
            </template>

        </b-modal>
    </div>
</template>

<script>

// Mixins
import compatibilityMatrixComparisonIA from '@/servicios/matrizCompatibilidad/almacenamiento/ia/mixins/comparison.js'

export default {

    name: 'MatrixCompatibilityModalComparison',

    mixins: [compatibilityMatrixComparisonIA],

}

</script>